import Cookies from 'universal-cookie';

declare global {
  interface Window {
    google: any;
  }
}

export class GoogleAuth {
  private gsi: any;
  private clientId: string = '';
  private cookies: Cookies;

  constructor() {
    this.cookies = new Cookies();
  }

  async load(clientId: string) {
    await this.createScript();
    this.clientId = clientId;
  }

  private createScript(): Promise<any> {
    return new Promise((resolve, reject) => {
      const el = document.getElementById('gsi_script_id');
      if (!el) {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://accounts.google.com/gsi/client');
        script.setAttribute('async', 'true');
        script.setAttribute('defer', 'defer');
        script.setAttribute('id', 'gsi_script_id');
        document.head.appendChild(script);

        script.onload = () => {
          this.gsi = window.google.accounts;
          resolve(this.gsi);
        };

        script.onerror = () => reject(new Error('Failed to load Google script'));
      } else {
        resolve(this.gsi || window.google?.accounts);
      }
    });
  }

  // eslint-disable-next-line
  signIn(callbackSuccess: Function, callbackFail: Function) {
    const params = {
      client_id: this.clientId,
      callback: callbackSuccess,
      use_fedcm_for_prompt: true,
    };

    this.gsi.id.initialize(params);
    this.gsi.id.prompt((notification: any) => {
      if (notification.isSkippedMoment()) {
        callbackFail(notification);
        // Remove cookie that blocks Google popup
        this.cookies.remove('g_state', { path: '/' });
      }
    });
  }

  grantOfflineAccess(scope: string): Promise<any> {
    return new Promise((resolve) => {
      const client = this.gsi.oauth2.initCodeClient({
        client_id: this.clientId,
        scope,
        ux_mode: 'popup',
        callback: (res: any) => resolve(res),
      });

      client.requestCode();
    });
  }
}